import { render, staticRenderFns } from "./MedicalCertificateDoc.vue?vue&type=template&id=fd901a54&scoped=true&"
import script from "./MedicalCertificateDoc.vue?vue&type=script&lang=js&"
export * from "./MedicalCertificateDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd901a54",
  null
  
)

export default component.exports